import IntegrateWebhook from 'components/organisms/IntegrateWebhook';

const webhookData = {
  key: 'WEBHOOK',
  renderAction: (data, refetch) => {
    return <IntegrateWebhook selectedIntegration={data} {...{ refetch }} />;
  }
};

export default webhookData;
